export default __webpack_public_path__ + "static/media/welcome-equipmentinventory-tracking.fecb3e04.png";